import { OpenAPIV2 } from 'openapi-types'
import swaggerfilesJSON from '../../swaggerfiles.json'

export const swaggerfiles = swaggerfilesJSON as OpenAPIV2.Document
